module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeSpoon.ad913dd1.png";